/**
 * Search Modal
 *
 * Toggles a full-viewport search overlay when the magnifying-glass button
 * in the header is clicked. Closes on the close button, Escape key, or a
 * click on the backdrop outside the inner container.
 */

export function initSearchModal() {
  const toggles = document.querySelectorAll('.search-modal__toggle');
  const modal  = document.getElementById('search-modal');
  const close  = modal ? modal.querySelector('.search-modal__close') : null;
  const input  = modal ? modal.querySelector('.search-modal__input') : null;

  if (!modal || !close) return;

  function openModal(e) {
    modal.removeAttribute('hidden');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    const btn = e && e.target && e.target.closest('.search-modal__toggle');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (input) input.focus();
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.querySelectorAll('.search-modal__toggle').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
    modal.addEventListener('transitionend', function handler() {
      if (!modal.classList.contains('is-open')) {
        modal.setAttribute('hidden', '');
      }
      modal.removeEventListener('transitionend', handler);
    });
    if (toggles.length && toggles[0]) toggles[0].focus();
  }

  // Use event delegation so dynamically-inserted toggles (e.g. mobile button) work too
  document.addEventListener('click', function (e) {
    if (e.target.closest('.search-modal__toggle')) openModal(e);
  });
  close.addEventListener('click', closeModal);

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // Close on backdrop click (outside the inner container)
  modal.addEventListener('click', function (e) {
    if (!e.target.closest('.search-modal__inner')) {
      closeModal();
    }
  });
}
